import axios from "utils/axios";

export const getUmpTenants = () => {
  return axios.get("/hr/umpTenants");
};

export const addUmpTenants = (data) => {
  return axios.post("/hr/umpTenants", data);
};
